import SellerApplications from "./SellerApplications";

export default SellerApplications;
